import * as React from "react";
const SvgLaptop = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M4.215 3.754v9.976l-1.356 3.25L1.5 20.244c-.004.01 2.1.012 10.5.012s10.504-.002 10.5-.012l-1.36-3.264-1.355-3.25V3.754H12ZM5.72 5.252H18.277v7.871H5.72V9.188Zm-.254 9.379h13.066l.856 2.056.855 2.057-4.121.002c-2.267.002-5.979.002-8.246 0l-4.123-.002.857-2.057z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgLaptop;
